// src/store/ApiPara/types.js

export const API_PARA_UPDATE_SUCCESS = 'API_PARA_UPDATE_SUCCESS';
export const API_PARA_UPDATE_FAILURE = 'API_PARA_UPDATE_FAILURE';

export const API_PARA_CLEAR_SUCCESS = 'API_PARA_CLEAR_SUCCESS';
export const API_PARA_CLEAR_FAILURE = 'API_PARA_CLEAR_FAILURE';
